import UpdateSessionCrewAssociations from '@/connection/crew/update-session-crew-associations';
import { serializeError } from '@/store/utils/serialize-error';
import { BLAdmin } from '@/types/profile.types';
import { ISessionCrew } from '@/types/session.types';
import { ProjectStateReducerCreator } from '../types';

const updateSessionCrewAssociationsReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      {
        sessionUuid,
        addedCrew,
        removedCrew,
      }: { sessionUuid: string; addedCrew?: BLAdmin[]; removedCrew?: ISessionCrew[] },
      { rejectWithValue }
    ) => {
      try {
        const updatedCrew = await UpdateSessionCrewAssociations({
          sessionUuid,
          addedCrewAdminIds: (addedCrew || []).map((crew) => crew.id),
          removedCrewAdminIds: (removedCrew || []).map((crew) => crew.bl_admin.id),
        });
        return { sessionUuid, updatedCrew };
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        // update session state to remove associated crew admins for UI re-rendering
        if (state.workingProject?.sessions.length) {
          state.workingProject.sessions = state.workingProject.sessions.map((session) => {
            if (session.uuid !== action.payload.sessionUuid) {
              return session;
            }
            session.crew = action.payload.updatedCrew;
            return session;
          });
        }
      },
      rejected: (_state, action) => {
        console.error(action.payload);
      },
    }
  );
};

export default updateSessionCrewAssociationsReducer;
